import React from "react";
import AppFooterWeb from "../../components/AppFooterWeb";

export class About extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <div className="banner-section">
          <div className="about-page">
            <div className="about-blank"></div>
            <div className="about-container">
              <img
                src={require("../../assets/images/About.png")}
                className="About-img"
                alt="About"
              />
              <h4>ELECTRIFIED: 50 Years of Electric Factory </h4> <br></br>
              <h5>
                Peck Center Gallery and Bossone Research Center, Drexel
                University <br></br> <br></br>
                September 22–December 31, 2023{" "}
              </h5>
              <br></br>
              <p>
                A major exhibition celebrating the impact of Philadelphia-based
                Electric Factory and Electric Factory Concerts, from the late
                1960s to the 2010s.<br></br>
                <br></br>
                In 1967 Larry Magid returned to his native Philadelphia,
                reconnecting with brothers Allen, Herb and Jerry Spivak, and
                Shelly Kaplan. Herb Spivak owned a jazz nightspot called the
                Showboat Theatre and was keen to harness Larry Magid’s
                experience as a talent agent in New York, who had been promoting
                upcoming rock and blues musicians. The two discussed plans to
                open a club that would be a hip, underground environment.
                <br></br>
                <br></br>
                When the original Electric Factory opened on Arch Street in
                February 1968, Philadelphia had a range of venues offering jazz,
                blues, soul, rhythm & blues, and rock, supported by local radio
                stations. Yet its impact was immediate, with Jimi Hendrix, Janis
                Joplin and Cream appearing in its first three months. Electric
                Factory Concerts (EFC) began shortly afterwards, mounting the
                three-day Atlantic City Pop Festival in 1969, just before
                Woodstock. Shortly after the original Electric Factory closed in
                1970, EFC opened the Bijou Café on Lombard St.<br></br>
                <br></br>
                With Larry Magid, as promoter, and Allen Spivak as business
                manager, EFC became the major concert producer on the east
                coast, managing thousands of concerts at the Spectrum and other
                venues. It co-produced Live Aid, partnering with Bob Geldorf,
                Bill Graham, and Harvey Goldsmith in London, and twenty years
                later Live 8. In 1995, the second Electric Factory opened in Old
                City.<br></br>
                <br></br>
                This unmissable exhibition will include original posters,
                photographs, and concert apparel. An American invention, the
                electric guitar is the signature instrument of rock and visitors
                will be drawn to Bruce Springsteen’s Fender Telecaster, played
                in Philadelphia more than any other celebrated guitar; the
                6-string bass Jack Bruce used to record Fresh Cream, painted in
                psychedelic colors for Cream’s 1968 European and US tours; and a
                late 1950s Gibson Les Paul, regarded by some as the holy grail
                of electric guitars, played by Mick Taylor at the Spectrum
                during the Stones’ tour in 1972.<br></br>
                <br></br>
                The exhibition includes sections on the early years of Electric
                Factory, Live Aid, concert sound systems (with a scaled-down
                stage), the 2nd Electric Factory, and the psychology of rhythm
                which underlies so much music. An interactive section will close
                the show, inviting guests to decorate guitars virtually.
                <br></br>
                <br></br>{" "}
              </p>
            </div>
          </div>
        </div>
        <AppFooterWeb
          pathName={this.props.location?.pathname}
          history={this.props.history}
        />
      </>
    );
  }
}

export default About;
